// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.forgotPass {
  width: 50%;
  height: 90%;
  background-color: #FFFFFF;
  border-radius: 1.25rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-around;
  padding: 1.25rem;
  position: absolute;
  opacity: 0;
  transition: all 0.7s ease-out;
  min-width: 23rem;
  min-height: 70%;
  overflow: auto;
}
.forgotPass.active {
  opacity: 1;
  z-index: 9;
}
.forgotPass.next {
  opacity: 0.3;
  transform: translate(0, 9%) scale(0.9);
}
.forgotPass .top {
  text-align: center;
}
.forgotPass .top img {
  width: 11rem;
}
.forgotPass .top h1 {
  margin: 2.5rem 0rem 0.6rem 0rem;
  font-size: 2.18rem;
  font-weight: 700;
  color: #232323;
}
.forgotPass .top p {
  margin: 0rem;
  font-size: 0.8rem;
  color: #232323;
  font-weight: 300;
  padding-bottom: 0.6rem;
}
.forgotPass .bottom {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  gap: 1rem;
}
.forgotPass .bottom p {
  font-size: 0.875rem;
  cursor: pointer;
  color: #102c97;
  font-weight: 700;
}
.forgotPass .bottom input {
  width: 80%;
  height: 1.8rem;
  outline: none;
  border: none;
  border-bottom: 1px solid #CEEDF9;
  text-indent: 0.6rem;
  background-color: transparent;
  font-size: 0.875rem;
}
.forgotPass .bottom button {
  width: 80%;
  height: 3.125rem;
  background-color: #102c97;
  color: white;
  outline: none;
  border: none;
  border-radius: 0.3rem;
  font-size: 1rem;
  font-weight: 700;
  margin-top: 0.6rem;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
}`, "",{"version":3,"sources":["webpack://./src/Components/Login/ForgotPassword/ForgotPassword.scss"],"names":[],"mappings":"AAAA;EAEI,UAAA;EACA,WAAA;EACA,yBAAA;EACA,sBAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,6BAAA;EACA,gBAAA;EACA,kBAAA;EACA,UAAA;EACA,6BAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;AAAJ;AACI;EACI,UAAA;EACA,UAAA;AACR;AACI;EACI,YAAA;EACA,sCAAA;AACR;AACI;EACI,kBAAA;AACR;AAAQ;EACI,YAAA;AAEZ;AAAQ;EACI,+BAAA;EACA,kBAAA;EACA,gBAAA;EACA,cAAA;AAEZ;AAAQ;EACI,YAAA;EACA,iBAAA;EACA,cAAA;EACA,gBAAA;EACA,sBAAA;AAEZ;AACI;EACI,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,WAAA;EACA,SAAA;AACR;AAAQ;EACI,mBAAA;EACA,eAAA;EACA,cAAA;EACA,gBAAA;AAEZ;AAAQ;EACI,UAAA;EACA,cAAA;EACA,aAAA;EACA,YAAA;EACA,gCAAA;EACA,mBAAA;EACA,6BAAA;EAEA,mBAAA;AACZ;AACQ;EACI,UAAA;EACA,gBAAA;EACA,yBAAA;EACA,YAAA;EACA,aAAA;EACA,YAAA;EACA,qBAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AACZ","sourcesContent":[".forgotPass{\n    // width: 35%;\n    width: 50%;\n    height: 90%;\n    background-color: #FFFFFF;\n    border-radius: 1.25rem;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: space-around;\n    padding: 1.25rem;\n    position: absolute;\n    opacity: 0;\n    transition: all 0.7s ease-out;\n    min-width: 23rem;\n    min-height: 70%;\n    overflow: auto;\n    &.active{\n        opacity: 1;\n        z-index: 9;\n    }\n    &.next{\n        opacity: .3;\n        transform: translate(0, 9%) scale(0.9);\n    }\n    .top{\n        text-align: center;\n        img{\n            width: 11rem;\n        }\n        h1{\n            margin: 2.5rem 0rem .6rem 0rem;\n            font-size: 2.18rem;\n            font-weight: 700;\n            color: #232323;\n        }\n        p{\n            margin: 0rem;\n            font-size: .8rem;\n            color: #232323;\n            font-weight: 300;\n            padding-bottom: .6rem;\n        }\n    }\n    .bottom{\n        display: flex;\n        flex-direction: column;\n        align-items: center;\n        width: 100%;\n        gap: 1rem;\n        p{\n            font-size: .875rem;\n            cursor: pointer;\n            color: #102c97;\n            font-weight: 700;\n        }\n        input{\n            width: 80%;\n            height: 1.8rem;\n            outline: none;\n            border: none;\n            border-bottom: 1px solid #CEEDF9;\n            text-indent: .6rem;\n            background-color: transparent;\n            // margin: 25px 0px;\n            font-size: 0.875rem;\n        }\n        button{\n            width: 80%;\n            height: 3.125rem;\n            background-color: #102c97;\n            color: white;\n            outline: none;\n            border: none;\n            border-radius: .3rem;\n            font-size: 1rem;\n            font-weight: 700;\n            margin-top: .6rem;\n            cursor: pointer;\n            display: flex;\n            align-items: center;\n            justify-content: center;\n        }\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
